import {ModelContext} from '../../types/app.types';

export class PriceModel {
  public convertedAmount: number;
  public formattedConvertedAmount: string;

  constructor(params: PriceModel) {
    this.convertedAmount = params.convertedAmount;
    this.formattedConvertedAmount = params.formattedConvertedAmount;
  }

  public static fromSDK(
    multiCurrencyPrice: {convertedAmount?: string; formattedConvertedAmount?: string},
    modelContext: ModelContext
  ) {
    return new PriceModel({
      convertedAmount: parseFloat(multiCurrencyPrice?.convertedAmount),
      formattedConvertedAmount: modelContext.formatAmount(multiCurrencyPrice?.convertedAmount),
    });
  }
}
